module.exports = __webpack_public_path__ + "media/fire.d2a15637.wav";